var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert_content"},[(_vm.message)?_c('b-alert',{attrs:{"show":"","dismissible":"","variant":_vm.type}},[_vm._v(_vm._s(_vm.message))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }